import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();



// WEBPACK FOOTER //
// ./src/history.js